<template>
  <div id="icommunity" class="c-content">
    <div class="c-childBanner l-margin-bottom-10">
      <div class="c-childBanner__text">
        <h2>
          <p @click="$router.push({name: 'community'})">{{icommunity.goBack}}</p>
          {{banner.title}}
        </h2>
        <p>{{banner.content}}</p>
        <q-btn outline class='c-publicity__watch--btn' @click='routeTo("icommunityApp")' :label="banner.download" padding="3px 2.5em" style='margin-top:10px; border-radius:0; color: #C6C6C6; line-height: 1.5em'/>
      </div>
      <div class="c-childBanner__img" style='right: 0; top: 0; left: unset'>
        <img :src="banner.img" alt="">
      </div>
    </div>

    <div class="c-drawer" :class="{'is-active': drawerActive}" :style="{backgroundImage:'url('+ drawer.img +')'}">
      <div :class="{'is-active': !drawerActive}" class="c-drawer__item c-drawer__left">
        <div class="c-drawer__text">
          <h3 class="title_h3" style="padding: 0 10px">{{ drawer.content[0].title }}</h3>
          <div class="c-drawer__content">
            <p v-for="(item, index) in drawer.content[0].items" :key="index">
              <b class='fa fa-angle-right' style='line-height: 1.5em'></b>
              <span>{{ item.content }}</span>
            </p>
          </div>
        </div>
      </div>
      <div :class="{'is-active': drawerActive}"  class="c-drawer__item c-drawer__right">
        <div class="c-drawer__text">
          <h3 class="title_h3" style="padding: 0 10px">{{ drawer.content[1].title }}</h3>
          <div class="c-drawer__content">
            <p v-for="(item, index) in drawer.content[1].items" :key="index">
              <b>{{ item.title }}</b>
              <span>{{ item.content }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="c-drawer__arrow" @click="toggleDrawer()">
        <i class="fa fa-angle-left"></i>
      </div>
    </div>
    <div class="c-imgBlock">
      <img :src="imgBlock.img_en" alt="" v-if="languageDefault == 'en_us'">
      <img :src="imgBlock.img_de" alt="" v-else-if="languageDefault == 'de_de'">
      <img :src="imgBlock.img" alt="" v-else>
    </div>
  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'

  export default {
    name: 'icommunity',
    components: {
      'q-btn': Quasar.QBtn,
    },
    data(){
      return {
        icommunity: {
          more: this.$t('common.more'),
          goBack: this.$t('menu.community_back'),
        },
        banner: {
          img: require('../../assets/img/publicity_3.jpg'),
          title: this.$t('icommunity.banner.title'),
          content: this.$t('icommunity.banner.content'),
          download: this.$t('icommunity.banner.download'),
        },
        languageDefault: localStorage.getItem('lang') || 'zh_cn',
        drawerActive: false,
        drawer: {
          img: require('../../assets/img/icommunity_twoblock.jpg'),
          content:[
            {
              title: this.$t('icommunity.drawer.left.title'),
              items:[
                {title: this.$t('icommunity.drawer.left.items.item_1.title'), content: this.$t('icommunity.drawer.left.items.item_1.content')},
                // {title: this.$t('icommunity.drawer.left.items.item_1.title'), content: this.$t('icommunity.drawer.left.items.item_1.content')},
                {title: this.$t('icommunity.drawer.left.items.item_2.title'), content: this.$t('icommunity.drawer.left.items.item_2.content')},
              ]
            },
            {
              title: this.$t('icommunity.drawer.right.title'),
              items:[
                {title: this.$t('icommunity.drawer.right.items.item_1.title'), content: this.$t('icommunity.drawer.right.items.item_1.content')},
                {title: this.$t('icommunity.drawer.right.items.item_2.title'), content: this.$t('icommunity.drawer.right.items.item_2.content')},
                {title: this.$t('icommunity.drawer.right.items.item_3.title'), content: this.$t('icommunity.drawer.right.items.item_3.content')},
              ]
            },
          ]
        },
        imgBlock:{
          img: require('../../assets/img/icommunity_sys-08.jpg'),
          img_en: require('../../assets/img/icommunity_sys-08_en.jpg'),
          img_de: require('../../assets/img/icommunity_sys-08_de.jpg')
        },
      }
    },
    computed: {

    },
    created () {

    },
    methods: {
      routeTo(link, index){
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },
      toggleDrawer(){
        this.drawerActive = !this.drawerActive
      },
      getQueryVariable(variable) {
        let query
        if (window.location.href.indexOf('?') > -1) {
          query = window.location.href.split('?')[1]
        } else {
          query = ""
        }
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
        }
        return(false);
      },
    },
  }
</script>

<style>

</style>
